import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62bba840"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "calendar-homework_wrapper" }
const _hoisted_2 = { class: "calendar-homework_wTop" }
const _hoisted_3 = {
  key: 0,
  class: "-icon"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_2707_60119)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M4.5 6V5.25C4.5 4.05653 4.97411 2.91193 5.81802 2.06802C6.66193 1.22411 7.80653 0.75 9 0.75C10.1935 0.75 11.3381 1.22411 12.182 2.06802C13.0259 2.91193 13.5 4.05653 13.5 5.25V6H15C15.1989 6 15.3897 6.07902 15.5303 6.21967C15.671 6.36032 15.75 6.55109 15.75 6.75V15.75C15.75 15.9489 15.671 16.1397 15.5303 16.2803C15.3897 16.421 15.1989 16.5 15 16.5H3C2.80109 16.5 2.61032 16.421 2.46967 16.2803C2.32902 16.1397 2.25 15.9489 2.25 15.75V6.75C2.25 6.55109 2.32902 6.36032 2.46967 6.21967C2.61032 6.07902 2.80109 6 3 6H4.5ZM14.25 7.5H3.75V15H14.25V7.5ZM8.25 11.799C7.96404 11.6339 7.74054 11.3791 7.61418 11.074C7.48782 10.7689 7.46565 10.4307 7.55111 10.1117C7.63657 9.79278 7.82489 9.51095 8.08686 9.30993C8.34882 9.10892 8.6698 8.99996 9 8.99996C9.3302 8.99996 9.65118 9.10892 9.91314 9.30993C10.1751 9.51095 10.3634 9.79278 10.4489 10.1117C10.5344 10.4307 10.5122 10.7689 10.3858 11.074C10.2595 11.3791 10.036 11.6339 9.75 11.799V13.5H8.25V11.799ZM6 6H12V5.25C12 4.45435 11.6839 3.69129 11.1213 3.12868C10.5587 2.56607 9.79565 2.25 9 2.25C8.20435 2.25 7.44129 2.56607 6.87868 3.12868C6.31607 3.69129 6 4.45435 6 5.25V6Z",
      fill: "#787F84"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_2707_60119" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "18",
        height: "18",
        fill: "white"
      })
    ])
  ])
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "calendar-homework_content" }
const _hoisted_7 = { class: "calendar-homework_top" }
const _hoisted_8 = { class: "calendar-homework_title" }
const _hoisted_9 = { class: "calendar-homework_bottom" }
const _hoisted_10 = { class: "calendar-homework_type -desktop" }
const _hoisted_11 = { class: "calendar-homework_wBottom" }
const _hoisted_12 = { class: "calendar-homework_wType" }
const _hoisted_13 = { class: "calendar-homework_wContent" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ac_points = _resolveComponent("ac-points")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: _ctx.homeworkLink,
    class: _normalizeClass(["calendar-homework", [_ctx.isDisabledStage ? '-disabled-stage' : '', `-${_ctx.status}`, `-${_ctx.homeworkType}`]]),
    disabled: _ctx.isDisabled,
    event: _ctx.isDisabled ? '' : 'click',
    "data-cy": `calendar-homework-${_ctx.localHomework.status.id}`
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(['calendar-homework_icon', `-${_ctx.status}`, _ctx.isDisabledStage ? '-disabled-stage' : ''])
          }, [
            (_ctx.isDisabled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.localHomework.homework.title), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('homework')), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", {
              class: _normalizeClass(['calendar-homework_type', `-${_ctx.status}`])
            }, _toDisplayString(_ctx.$t('HW')), 3)
          ]),
          _createElementVNode("div", _hoisted_13, [
            (_ctx.isShowPoints)
              ? (_openBlock(), _createBlock(_component_ac_points, {
                  key: 0,
                  class: _normalizeClass(["calendar-homework_points", [`-${_ctx.status}`]])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.pointsText), 1)
                  ]),
                  _: 1
                }, 8, ["class"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(['calendar-homework_status', `-${_ctx.status}`])
            }, _toDisplayString(_ctx.statusText), 3)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["to", "class", "disabled", "event", "data-cy"]))
}